const RecordIcon = ({ className = '' }) => {
  return (
    <svg className={`inline fill-current ${className}`} viewBox="0 0 97 97">
      <path d="M48.5.5a48 48 0 1 0 0 96 48 48 0 0 0 0-96Zm25.85 64.2a1.5 1.5 0 0 1 2.54 1.6A33.35 33.35 0 0 1 48.5 82a1.5 1.5 0 1 1 0-3 30.36 30.36 0 0 0 25.85-14.3ZM14.45 29a1.5 1.5 0 0 1-1.28-2.29A41.28 41.28 0 0 1 48.5 7a1.5 1.5 0 0 1 0 3 38.29 38.29 0 0 0-32.77 18.29 1.5 1.5 0 0 1-1.28.71Zm8.2 3.3a1.5 1.5 0 0 1-2.54-1.6A33.35 33.35 0 0 1 48.5 15a1.5 1.5 0 1 1 0 3 30.36 30.36 0 0 0-25.85 14.3Zm6.85 16.2a19 19 0 1 1 38 0 19 19 0 0 1-38 0Zm19 41.5a1.5 1.5 0 1 1 0-3c13.45 0 25.7-6.84 32.77-18.29a1.5 1.5 0 1 1 2.56 1.58A41.27 41.27 0 0 1 48.5 90Zm4-41.5a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z" />
    </svg>
  )
}
export default RecordIcon
